import { jsx as n, jsxs as h } from "react/jsx-runtime";
import x from "clsx";
import { forwardRef as B, useRef as I, useState as i, useCallback as M, useEffect as p } from "react";
const R = (t) => x(t), T = (t) => (o) => {
  t.forEach((e) => {
    typeof e == "function" ? e(o) : e != null && (e.current = o);
  });
}, s = "dds-banner-notification-v0162", j = {
  note: "Note",
  reminder: "Reminder",
  caution: "Caution",
  verify: "Verify",
  success: "Success",
  error: "Error",
  invalid: "Invalid",
  "system-error": "System error"
}, A = {
  note: /* @__PURE__ */ n(
    "path",
    {
      d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M4,6.37H3.43c-0.24,0-0.42-0.23-0.36-0.46l0.45-1.82
H3.43c-0.21,0-0.37-0.17-0.37-0.38c0-0.2,0.16-0.37,0.37-0.37H4c0.24,0,0.42,0.23,0.36,0.46L3.9,5.63H4c0.21,0,0.37,0.16,0.37,0.37
S4.21,6.37,4,6.37z M4,2.86c-0.32,0-0.57-0.26-0.57-0.57c0-0.32,0.25-0.58,0.57-0.58s0.57,0.26,0.57,0.58C4.57,2.6,4.32,2.86,4,2.86
z`
    }
  ),
  reminder: /* @__PURE__ */ n(
    "path",
    {
      d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M4,6.37H3.43c-0.24,0-0.42-0.23-0.36-0.46l0.45-1.82
H3.43c-0.21,0-0.37-0.17-0.37-0.38c0-0.2,0.16-0.37,0.37-0.37H4c0.24,0,0.42,0.23,0.36,0.46L3.9,5.63H4c0.21,0,0.37,0.16,0.37,0.37
S4.21,6.37,4,6.37z M4,2.86c-0.32,0-0.57-0.26-0.57-0.57c0-0.32,0.25-0.58,0.57-0.58s0.57,0.26,0.57,0.58C4.57,2.6,4.32,2.86,4,2.86
z`
    }
  ),
  caution: /* @__PURE__ */ n(
    "path",
    {
      d: `M7.93,6.91L4.52,0.54c-0.22-0.41-0.82-0.41-1.04,0L0.07,6.91C-0.14,7.3,0.14,7.77,0.59,7.77h6.82
C7.86,7.77,8.14,7.3,7.93,6.91z M3.56,2.94C3.56,2.7,3.76,2.5,4,2.5s0.44,0.2,0.44,0.44V4.4c0,0.25-0.2,0.44-0.44,0.44
S3.56,4.65,3.56,4.4V2.94z M4,6.6c-0.32,0-0.59-0.26-0.59-0.59c0-0.32,0.27-0.58,0.59-0.58s0.59,0.26,0.59,0.58
C4.59,6.34,4.32,6.6,4,6.6z`
    }
  ),
  verify: /* @__PURE__ */ n(
    "path",
    {
      d: `M7.93,6.91L4.52,0.54c-0.22-0.41-0.82-0.41-1.04,0L0.07,6.91C-0.14,7.3,0.14,7.77,0.59,7.77h6.82
C7.86,7.77,8.14,7.3,7.93,6.91z M3.56,2.94C3.56,2.7,3.76,2.5,4,2.5s0.44,0.2,0.44,0.44V4.4c0,0.25-0.2,0.44-0.44,0.44
S3.56,4.65,3.56,4.4V2.94z M4,6.6c-0.32,0-0.59-0.26-0.59-0.59c0-0.32,0.27-0.58,0.59-0.58s0.59,0.26,0.59,0.58
C4.59,6.34,4.32,6.6,4,6.6z`
    }
  ),
  success: /* @__PURE__ */ n(
    "path",
    {
      d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M5.8,2.97l-2,2.75C3.67,5.91,3.4,5.93,3.23,5.77
l-1-1c-0.14-0.15-0.14-0.39,0-0.54c0.15-0.14,0.39-0.14,0.54,0l0.68,0.69L5.2,2.53c0.12-0.17,0.35-0.21,0.52-0.08
C5.89,2.57,5.93,2.8,5.8,2.97z`
    }
  ),
  error: /* @__PURE__ */ n(
    "path",
    {
      d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
    }
  ),
  invalid: /* @__PURE__ */ n(
    "path",
    {
      d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
    }
  ),
  "system-error": /* @__PURE__ */ n(
    "path",
    {
      d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
    }
  )
}, G = B(
  ({
    children: t,
    className: o = "",
    removedAfterDismiss: e = !1,
    dismissible: L = !1,
    variant: C = "error",
    prefixOverride: g,
    showPrefix: y = !0,
    ..._
  }, v) => {
    const N = {
      [s]: !0,
      [`${s}--${C}`]: !0,
      [o]: o.length > 0
    }, r = I(null), [$, V] = i(!0), [a, d] = i(!1), [b, u] = i([]), [S, z] = i(!1), [H, m] = i({}), l = M(() => {
      e && V(!1), d(!1), u([`${s}--closed`]);
    }, [e]), E = M(
      (c) => {
        a && c.target === r.current && l();
      },
      [l, r, a]
    ), w = M(() => {
      u([`${s}--closing`]), d(!0);
    }, [u, d]);
    return p(() => {
      if (a) {
        const c = setTimeout(() => {
          l();
        }, 2e3);
        return () => clearTimeout(c);
      }
      return () => {
      };
    }, [a, l]), p(() => {
      var c;
      if (!S) {
        z(!0);
        const f = (c = r.current) == null ? void 0 : c.getBoundingClientRect();
        m({ height: f == null ? void 0 : f.height });
      }
    }, [S, z, m]), $ ? /* @__PURE__ */ n(
      "div",
      {
        className: `${R(N)} ${b.join(" ")}`,
        ..._,
        onTransitionEnd: E,
        ref: T([r, v]),
        style: H,
        children: /* @__PURE__ */ h("div", { className: `${s}__inner`, children: [
          /* @__PURE__ */ n("svg", { className: `${s}__glyph`, viewBox: "0 0 8 8", children: A[C] }),
          /* @__PURE__ */ h("span", { className: `${s}__content`, children: [
            y && /* @__PURE__ */ h("span", { className: `${s}__label`, children: [
              g ?? j[C],
              ":"
            ] }),
            t
          ] }),
          L && /* @__PURE__ */ n(
            "button",
            {
              className: `${s}__close-button`,
              type: "button",
              name: "Close notification",
              onClick: w,
              "aria-label": "Close notification",
              children: /* @__PURE__ */ n("svg", { className: `${s}__close-glyph`, viewBox: "0 0 8 8", children: /* @__PURE__ */ n("path", { d: "M1.046,0.118c-0.26-0.18-0.619-0.154-0.85,0.077c-0.26,0.26-0.26,0.682,0,0.943L3.057,4L0.195,6.862L0.118,6.954c-0.18,0.26-0.154,0.619,0.077,0.85c0.26,0.26,0.682,0.26,0.943,0L4,4.943l2.862,2.862l0.092,0.077c0.26,0.18,0.619,0.154,0.85-0.077c0.26-0.26,0.26-0.682,0-0.943L4.943,4l2.862-2.862l0.077-0.092c0.18-0.26,0.154-0.619-0.077-0.85c-0.26-0.26-0.682-0.26-0.943,0L4,3.057L1.138,0.195L1.046,0.118z" }) })
            }
          )
        ] })
      }
    ) : null;
  }
);
export {
  G as BannerNotification
};
//# sourceMappingURL=index.js.map
